(function () {
    'use strict';

    // ── Reusable OTP countdowns ──────────────────────────────────────────────
    // The one OTP countdown script (sign-up's own id-based copy went 2026-09-27), so ANY OTP
    // panel (login, phone verify, …) gets the same behaviour by opting in:
    //   TTL:    <span   class="js-otp-ttl"    data-ttl="300">           → "M:SS" then "Expired"
    //   Resend: <button class="js-otp-resend" data-resend-cooldown="60"> → disabled
    //           "Resend in Ns" during the cooldown, then re-enabled to its original label.
    // querySelectorAll (not getElementById) so multiple/any controls per page work.
    // Re-inits on load and after every HTMX swap, clearing prior intervals so swaps
    // don't stack — same pattern as signup.js.

    var ttlIntervals = [];
    var resendIntervals = [];
    function clearAll(list) { while (list.length) { clearInterval(list.pop()); } }

    function initTtl() {
        clearAll(ttlIntervals);
        document.querySelectorAll('.js-otp-ttl').forEach(function (el) {
            var remaining = parseInt(el.dataset.ttl, 10);
            if (isNaN(remaining)) { return; }
            var render = function () {
                if (remaining <= 0) { el.textContent = 'Expired'; return; }
                var m = Math.floor(remaining / 60).toString();
                var s = (remaining % 60).toString().padStart(2, '0');
                el.textContent = m + ':' + s;
            };
            render();
            var iv = setInterval(function () {
                if (remaining <= 0) { clearInterval(iv); el.textContent = 'Expired'; return; }
                remaining--; render();
            }, 1000);
            ttlIntervals.push(iv);
        });
    }

    function initResend() {
        clearAll(resendIntervals);
        document.querySelectorAll('.js-otp-resend').forEach(function (btn) {
            var remaining = parseInt(btn.dataset.resendCooldown, 10);
            if (isNaN(remaining) || remaining <= 0) { return; }
            // Preserve the button's own label (e.g. "Send a new code" / "Resend code")
            // so this script stays copy-agnostic across pages.
            if (!btn.dataset.resendLabel) { btn.dataset.resendLabel = btn.textContent.trim(); }
            var label = btn.dataset.resendLabel;
            var render = function () {
                if (remaining > 0) { btn.disabled = true; btn.textContent = 'Resend in ' + remaining + 's'; }
                else { btn.disabled = false; btn.textContent = label; }
            };
            render();
            var iv = setInterval(function () {
                remaining--; render();
                if (remaining <= 0) { clearInterval(iv); }
            }, 1000);
            resendIntervals.push(iv);
        });
    }

    function initAll() { initTtl(); initResend(); }
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('htmx:afterSwap', initAll);
}());
